export default function grouper() {
  const targets = Array.from(document.querySelectorAll('[data-group]'));
  const groups = {};

  targets.forEach((target)=>{
    const {dataset:{group=""}} = target;
    if(!groups[group]) groups[group] = [];
    target.style.setProperty('--index',groups[group].length);
    groups[group].push(target);
  });

  Object.keys(groups).forEach(key => {
    const {length} = Array.from(document.querySelectorAll(`[data-group="${key}"]`));
    const group = groups[key];
    group.forEach(element => element.style.setProperty('--length',length));
  });

  return groups;
}